module.exports = __webpack_public_path__ + "img/logo-white.051c8d9c.png";